import { useIdentityContext, useWebSocketContext } from '@flik/shared';
import React, { useEffect } from 'react';
import { useSessionInvitation } from '../contexts/SessionInvitationContext';
import { SessionInvitation } from './SessionInvitationModal';

const SessionInvitationHandler: React.FC = () => {
  const { onMessageReceived } = useWebSocketContext();
  const { showInvitation } = useSessionInvitation();
  const { isLoggedIn } = useIdentityContext();

  // Register message handler for session invitations
  useEffect(() => {
    const cleanup = onMessageReceived('onInvitedToSession', (message) => {
      console.log('Invited to session received:', message);

      // Only show invitation if user is logged in
      if (!isLoggedIn) {
        console.log('User not logged in, ignoring invitation');
        return;
      }

      const invitation: SessionInvitation = {
        id: `${Date.now()}-${Math.random()}`,
        sessionId: message.data.sessionId,
        sessionTitle: message.data.sessionTitle,
        createdBy: message.data.createdBy,
        inviteLink: message.data.inviteLink,
        timestamp: message.data.timestamp,
      };

      showInvitation(invitation);
    });

    return () => {
      console.log(
        'SessionInvitationHandler: Cleaning up onInvitedToSession handler',
      );
      cleanup();
    };
  }, [onMessageReceived, showInvitation, isLoggedIn]);

  // This component doesn't render anything - it just handles WebSocket messages
  return null;
};

export default SessionInvitationHandler;
